/**
 * Export-side state: the latest budget projection, published by the Budget
 * panel after a run so the export menu can offer it as CSV (the previous app
 * kept it in LoaderState.budgetProjection).
 */
import { create } from 'zustand';
import type { BudgetProjection } from '../analysis/types';

interface ExportState {
  budgetProjection: BudgetProjection | null;
  setBudgetProjection: (projection: BudgetProjection | null) => void;
}

export const useExportState = create<ExportState>()((set) => ({
  budgetProjection: null,
  setBudgetProjection: (budgetProjection) => set({ budgetProjection }),
}));

/** Called by the Budget panel when a projection finishes (or is cleared). */
export function setBudgetProjection(projection: BudgetProjection | null): void {
  useExportState.getState().setBudgetProjection(projection);
}
